export var BUFFER_TIME = 300000; // 5分钟
export var applyBufferTimer = function (checkIfNeedCancel, cb, bufferTime) {
    var tid = 0;
    return function () {
        if (checkIfNeedCancel()) {
            tid && clearTimeout(tid);
            tid = 0;
            return;
        }
        tid === 0 && (tid = setTimeout(cb, bufferTime));
    };
};
//# sourceMappingURL=time.js.map